import { Result } from "antd";
import strings from "i18n/strings";
import React, { Component } from "react";
import Auth from "./components/Auth";
import CenteredLayout from "./components/CenteredLayout";
import Upload from "./components/Upload";
import api from "./services/api";
import matterId from "./services/matterId";

class Root extends Component {
  constructor(props) {
    super(props);
    this.state = { user: null, loadingUser: true, error: null };
    this.sessionCheckVersion = 0;
  }

  onAuth(user) {
    this.sessionCheckVersion += 1;
    this.setState({ user, loadingUser: false, error: null });
  }

  componentDidMount() {
    this.mounted = true;
    this.unsubscribeUnauthorized = api.onUnauthorized(() => {
      this.onAuth(null);
    });
    const version = ++this.sessionCheckVersion;
    api
      .authenticatedUser()
      .then((user) => {
        if (this.mounted && version === this.sessionCheckVersion)
          this.onAuth(user);
      })
      .catch((error) => {
        if (!this.mounted || version !== this.sessionCheckVersion) return;
        if (error.response && error.response.status === 401) this.onAuth(null);
        else this.setState({ error, loadingUser: false });
      });
  }

  componentWillUnmount() {
    this.mounted = false;
    this.unsubscribeUnauthorized();
  }

  render() {
    if (!matterId)
      return (
        <CenteredLayout>
          <Result
            status="warning"
            title={strings.incorrectURL}
            subTitle={strings.requestCorrectURL}
          />
        </CenteredLayout>
      );
    if (this.state.loadingUser) return <></>;
    if (this.state.error)
      return (
        <CenteredLayout>
          <Result status="error" title={strings.errorOccured} />
        </CenteredLayout>
      );
    if (!this.state.user) return <Auth onSuccess={this.onAuth.bind(this)} />;

    return <Upload user={this.state.user} />;
  }
}

export default Root;
